export const TestRecord = require('./record.json');